"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const AreaTabs_vue_1 = __importDefault(require("./AreaTabs.vue"));
const TopbarMap_vue_1 = __importDefault(require("./TopbarMap.vue"));
const TopbarDownloadedMap_vue_1 = __importDefault(require("./TopbarDownloadedMap.vue"));
const axios_1 = __importDefault(require("axios"));
const Metadata_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Metadata.vue"));
const BaseMap_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BaseMap.vue"));
const floating_vue_1 = require("floating-vue");
const trans_1 = require("@common/tsutils/trans");
const GISArea_1 = __importDefault(require("@becrop/components/Modules/Common/Models/GISArea"));
const DBFMetadata_1 = __importDefault(require("@becrop/components/Modules/Common/Models/DBFMetadata"));
const MetadataColumns_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MetadataColumns"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const lucide_vue_next_2 = require("lucide-vue-next");
const jszip_1 = __importDefault(require("jszip"));
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const MapMarker_1 = __importDefault(require("@becrop/components/Map/models/MapMarker"));
const Utils_1 = require("@becrop/components/Map/Utils");
const HeaderMap_vue_1 = __importDefault(require("../../../Results/AreaProjectMap/HeaderMap.vue"));
const FooterMap_vue_1 = __importDefault(require("../../../Results/AreaProjectMap/FooterMap.vue"));
const MapSideBar_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBar.vue"));
const SampleProjectAssociation_vue_1 = __importDefault(require("./Components/SampleProjectAssociation.vue"));
const GeoEntities_1 = require("../../../../abstract/Models/GeoEntities");
const GeometryCollection_1 = __importDefault(require("ol/geom/GeometryCollection"));
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const format_1 = require("ol/format");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let AreaPlaygroundYield = class AreaPlaygroundYield extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // connector = new BaseMapConnector(this.map_config);
        this.mapController = new Controller_1.default();
        this.containerMapId = (0, vue_1.ref)(null);
        this.viewMode = this.mode;
        this.tabActive = 0;
        this.areasBuilt = this.areas;
        this.activeModalUploading = false;
        this.activeModalGISSave = false;
        this.activeModalCompleteMetadata = false;
        this.isSuccessfulUpload = true;
        this.isSuccessfulSave = true;
        this.isLoadingModalUploading = false;
        this.isLoadingSaveGISFiles = false;
        this.isStoredAsParcels = false;
        this.polygonShapes = [];
        this.samplingPoints = [];
        this.dbfFields = new DBFMetadata_1.default({});
        this.typeFileFormat = '';
        this.gisFileRecords = [];
        this.selectedMetadataColumns = new MetadataColumns_1.default({});
        this.fileNameMap = '';
        this.breakdownActive = '';
        this.isModalSampleAssocVisible = false;
        this.activePanel = '';
        this.cropColor = '#ffffff';
        this.callback = {
            title: '',
            subtitle: '',
            errors: [],
            emp: '',
        };
        this.loading = {
            title: '',
            subtitle: '',
        };
        this.compatibleProjectSlugs = ['rate', 'diseases', 'management', 'yield'];
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.imgDownloadView = false;
        this.isDeployModalExport = false;
        this.currentExtValue = '';
        this.source = 'tracking';
        this.fnmfwp = false;
        this.eventTracker = new EventTracker_1.default();
        this.loaderViewDetailsBreakdownArea = false;
        this.loaderViewDetailsBreakdownProposal = false;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    updateSideBarPanel(panel) {
        (this.activePanel === panel) ? this.activePanel = '' : this.activePanel = panel;
    }
    showModalSampleAssociation() {
        this.isModalSampleAssocVisible = true;
    }
    hideModalSampleAssociation() {
        this.isModalSampleAssocVisible = false;
    }
    mounted() {
        // @ts-ignore
        this.mapController.create(this.containerMapId, this.map_config.provider, this.map_config.apikey, '', '', '');
        if (this.mode === 'mapzones') {
            this.areasBuilt = this.areas;
            const currentAreaBuilt = new GISArea_1.default(JSON.parse(JSON.stringify(this.areaSelected.area)));
            this.areasBuilt.forEach((zone) => {
                zone.samplingPoints.forEach((sp) => {
                    currentAreaBuilt.samplingPoints.push(sp);
                });
            });
            currentAreaBuilt.meta.extension = '0';
            this.areasBuilt.unshift(currentAreaBuilt);
            this.loadTab(0);
        }
        if (this.mode === 'view') {
            this.buildColor();
            this.loadPolygonsArea();
            this.drawParcelsAndSamples();
        }
        this.buildColor();
        this.checkUrlParameters();
    }
    updated() {
        if (this.mode === 'mapzones') {
            this.areasBuilt = this.areas;
            const currentAreaBuilt = new GISArea_1.default(JSON.parse(JSON.stringify(this.areaSelected.area)));
            this.areasBuilt.forEach((zone) => {
                zone.samplingPoints.forEach((sp) => {
                    currentAreaBuilt.samplingPoints.push(sp);
                });
            });
            currentAreaBuilt.meta.extension = '0';
            this.areasBuilt.unshift(currentAreaBuilt);
            this.loadTab(0);
        }
    }
    checkUrlParameters() {
        const url = new URL(window.location.href);
        if (url.searchParams.has('sampling')) {
            url.searchParams.delete('sampling');
            url.searchParams.delete('area_id');
            this.activePanel = 'sampling-points';
            this.isModalSampleAssocVisible = true;
            window.history.pushState({}, document.title, url);
        }
    }
    get showMapSideBar() {
        if (!this.samplingPoints) {
            return false;
        }
        return this.samplingPoints.length > 0;
    }
    async drawParcelsAndSamples() {
        (0, Utils_1.removeLayerById)('zone-layer', this.mapController.map);
        (0, Utils_1.removeLayerById)('point-layer', this.mapController.map);
        const polygonsWkt = [];
        this.polygonShapes.forEach((shape, index) => {
            const shapeGeodata = (typeof shape === "string") ? shape : shape.polygon;
            const feature = new format_1.WKT().readFeature(shapeGeodata, this.mapController.zoneBuilder.projections);
            polygonsWkt.push(feature.getGeometry());
            this.mapController.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: (0, Utils_1.polygonToMultiPolygonWKT)(shapeGeodata),
                zoneName: `${shape.name}-${index}` || null,
                fillColor: this.changeColorOpacity(this.cropColor, 50),
                strokeColor: this.cropColor,
                centerZone: false,
                enableHoverInteraction: false,
                avg: 0,
                markers: [],
                preciseResult: false
            }));
        });
        const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
        (0, CenterUtility_1.center)(this.mapController.map, combinedGeometry.getExtent(), 700, [100, 100, 100, 100]);
        const points = new Set(this.samplingPoints);
        points.forEach((sample) => {
            this.mapController.pointBuilder.drawPoint(new MapMarker_1.default({ geoData: sample.geodata, enableHoverInteraction: true, enableSelectInteraction: true, color: this.cropColor, code: sample.sample_code }));
        });
    }
    changeColorOpacity(color, opacity) {
        const isRGB = color.match(/\,/g);
        if (this.cropColor.length === 7) {
            return color + opacity;
        }
        else if (isRGB && isRGB.length === 2) {
            return color.replace(')', `, ${opacity / 100})`);
        }
        return '#ffffff50';
    }
    changeStoreAsParcels(newValue) {
        this.isStoredAsParcels = newValue;
    }
    deployModalExport() {
        this.isDeployModalExport = true;
    }
    dismissModalExport() {
        this.isDeployModalExport = false;
    }
    formatExtensionAreaNameForExt(areaName) {
        const formatName = areaName.split(' ');
        return `${formatName[0]}_${formatName[1]}`;
    }
    zoomIn() {
        this.mapController.zoomIn();
    }
    zoomOut() {
        this.mapController.zoomOut();
    }
    onMapExport(format) {
        const filename = this.areaSelected.area.meta.name + ' - ' + format;
        this.mapController.exportBuilder.export(filename, format);
    }
    mapScreenshot() {
        this.imgDownloadView = true;
        setTimeout(() => {
            this.imgDownloadView = false;
        }, 1000);
        this.currentExtValue = '';
    }
    deployModalUploading() {
        this.activeModalUploading = true;
    }
    deployModalGISSave() {
        this.activeModalGISSave = true;
    }
    deployModalCompleteMetadata() {
        this.activeModalGISSave = false;
        this.dismissModalUploading();
        this.activeModalCompleteMetadata = true;
    }
    deployLoadingModalUploading() {
        this.isLoadingModalUploading = true;
    }
    dismissModalUploading() {
        this.callback.title = '';
        this.callback.subtitle = '';
        this.callback.errors = [];
        this.callback.emp = '';
        this.isSuccessfulUpload = false;
        this.activeModalUploading = false;
    }
    dismissLoadingModalUploading() {
        this.isLoadingModalUploading = false;
    }
    dismissModalGISSave() {
        this.activeModalGISSave = false;
        if (this.isSuccessfulSave) {
            this.setPhaseAsDone('gis_file_upload', this.areas[this.tabActive].meta.id);
        }
    }
    dismissModalCompleteMetadata() {
        this.activeModalCompleteMetadata = false;
    }
    trackInteractionValidationModal(a) {
        this.dismissModalUploading();
        this.mixpanelHandler.trackEvent('validationGISModal', {
            action: a,
        });
    }
    trackInteractionOnMap(a) {
        this.mixpanelHandler.trackEvent('previewGISMap', {
            action: a,
        });
    }
    setPhaseAsDone(phaseSlug, areaID) {
        this.$emit('setphaseasdone', phaseSlug, areaID);
    }
    updateDBFMetadataSelections(selections) {
        this.selectedMetadataColumns = selections;
    }
    async saveGISFiles() {
        if (this.isLoadingSaveGISFiles) {
            return;
        }
        this.isLoadingSaveGISFiles = true;
        this.trackInteractionOnMap('finish');
        this.loading.title = (0, trans_1.trans)('tracking.saving');
        this.loading.subtitle = (0, trans_1.trans)('tracking.saving_sub');
        this.callback.subtitle = '';
        this.callback.emp = '';
        this.deployLoadingModalUploading();
        const objToSave = {
            type: this.typeFileFormat,
            file_name: this.fileNameMap,
            gis_area_id: this.areas[this.tabActive].meta.id,
            keep_parcels: this.isStoredAsParcels,
            metadata_columns: this.selectedMetadataColumns,
            gis_file_records: this.gisFileRecords,
            source: this.source
        };
        // Pass the check value to store the parcels
        try {
            const data = await axios_1.default.post('/tracking/saveloaded', objToSave);
            const res = await data;
            this.isSuccessfulSave = true;
            this.callback.title = (0, trans_1.trans)('tracking.cbok');
            if (res.data.message.includes('span')) {
                this.callback.subtitle = res.data.message.substring(0, res.data.message.indexOf('('));
                const spanRegex = /<span>(.*?)<\/span>/;
                const match = res.data.message.match(spanRegex);
                this.callback.emp = match ? match[1] : null;
            }
            else {
                this.callback.subtitle = res.data.message;
            }
            if (this.callback.subtitle.length === 0) {
                this.callback.subtitle = (0, trans_1.trans)('tracking.cboksub');
            }
        }
        catch (e) {
            this.isSuccessfulSave = false;
            this.callback.title = (0, trans_1.trans)('tracking.cberr');
            this.callback.subtitle =
                e.response.data.message === '' ? e.message : e.response.data.message;
            if (e.response.data.error.length > 0) {
                let tempMsg = '';
                e.response.data.error.forEach((err) => {
                    tempMsg += err.message + '\n';
                });
                this.callback.subtitle = tempMsg;
            }
        }
        finally {
            this.isLoadingSaveGISFiles = false;
        }
        this.dismissLoadingModalUploading();
        this.deployModalGISSave();
    }
    typeExt(name) {
        if (name.includes('.kmz')) {
            return 'kml';
        }
        else {
            return name.slice(name.lastIndexOf('.') + 1, name.length);
        }
    }
    convertKMZtoKML(kmzFile) {
        const zip = new jszip_1.default();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const zipData = e.target.result;
                    zip.loadAsync(zipData).then((contents) => {
                        let kmlFile = null;
                        for (const fileName in contents.files) {
                            if (fileName.toLowerCase().endsWith('.kml')) {
                                kmlFile = contents.files[fileName];
                                break;
                            }
                        }
                        if (kmlFile) {
                            kmlFile.async('string').then((kmlContent) => {
                                resolve(kmlContent);
                            });
                        }
                        else {
                            reject(new Error('No se encontró ningún archivo KML en el KMZ.'));
                        }
                    });
                }
                catch (error) {
                    reject(error);
                }
            };
            reader.readAsArrayBuffer(kmzFile);
        });
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    async sendFiles(files, EPSG) {
        const formData = new FormData();
        const newformData = new FormData();
        let typeFile = 'shp';
        let typeFileFormat = 'shp';
        const newsFiles = [];
        for (const file of files) {
            formData.append('file-' + this.typeExt(file === null || file === void 0 ? void 0 : file.name), file);
        }
        if (files[0].name.includes('kml')) {
            typeFile = 'kml';
        }
        this.eventTrackerListener('Upload shapefiles/KML files', { typeFile: typeFile });
        if (files[0].name.endsWith('kml') || files[0].name.endsWith('kmz')) {
            typeFileFormat = 'kml';
        }
        if (files[0].name.includes('kmz') || files[0].name.includes('KMZ')) {
            this.fnmfwp = true;
            function crearFicheroKML(contenido) {
                const nombreArchivo = `${files[0].name.split('.')[0]}.kml`;
                // Crear un objeto Blob con el contenido del archivo
                const archivoBlob = new Blob([contenido], {
                    type: 'application/vnd.google-earth.kml+xml',
                });
                const archivo = new File([archivoBlob], nombreArchivo);
                return archivo;
            }
            await this.convertKMZtoKML(files[0])
                .then((result) => {
                newsFiles.push(crearFicheroKML(result));
                for (const file of newsFiles) {
                    newformData.append('file-' + 'kml', file);
                }
            })
                .catch((error) => {
                console.error(error);
            });
        }
        newformData.append('type', 'kml');
        newformData.append('prj_code', EPSG);
        newformData.append('source', this.source);
        formData.append('type', typeFile);
        formData.append('prj_code', EPSG);
        formData.append('source', this.source);
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        this.loading.title = (0, trans_1.trans)('tracking.processing');
        this.loading.subtitle = (0, trans_1.trans)('tracking.processing_desc');
        this.deployLoadingModalUploading();
        try {
            const data = await axios_1.default.post(baseURL + '/tracking/preload', this.fnmfwp ? newformData : formData);
            const res = data;
            const polygons = res.data.polygons;
            const metadataFields = res.data.metadata_fields;
            const gisFileRecords = res.data.gis_file_records;
            const fileNameMap = res.data.file_name;
            this.isSuccessfulUpload = true;
            this.callback.title = (0, trans_1.trans)('tracking.cbok');
            this.callback.subtitle = res.data.msg;
            this.polygonShapes = polygons;
            this.dbfFields = metadataFields;
            this.typeFileFormat = typeFileFormat;
            this.gisFileRecords = gisFileRecords;
            this.fileNameMap = fileNameMap;
            this.drawParcelsAndSamples();
            this.$emit('changeMapTabsVisibility', false);
        }
        catch (e) {
            this.isSuccessfulUpload = false;
            this.callback.title = (0, trans_1.trans)('tracking.cberr');
            this.callback.subtitle =
                e.response.data.message === '' ? e.message : e.response.data.message;
            this.callback.errors = e.response.data.error.map((er) => er.message);
        }
        this.dismissLoadingModalUploading();
        this.deployModalUploading();
    }
    launchCrumb(name) {
        this.breadcrumbClicked(name);
        this.$emit('launchcrumb', name);
    }
    breadcrumbClicked(name) {
        this.mixpanelHandler.trackEvent('breadcrumbClicked', {
            target: name,
            origin: 'playground',
        });
    }
    exitPlayground() {
        this.mixpanelHandler.trackEvent('exitAreaPlayground', {
            proposalId: this.proposal.id,
        });
    }
    loadTab(t) {
        this.mixpanelHandler.trackEvent('areaTabInPlayground', {
            proposalId: this.proposal.id,
        });
        this.tabActive = t;
        if (this.mode === 'mapzones') {
            this.loadPolygonsArea();
            this.loadSamplingPointsArea();
            this.buildColor();
            this.drawParcelsAndSamples();
        }
        else if (this.mode === 'view') {
            this.$emit('loadareatab', t);
        }
        else {
            this.$emit('loadareatab', t);
        }
    }
    created() {
        this.loadSamplingPointsArea();
    }
    updateMap() {
        // if (this.mode === 'view') {
        //     this.buildColor();
        //     this.loadPolygonsArea();
        //     this.drawParcelsAndSamples();
        // }
        this.buildColor();
        this.loadPolygonsArea();
        this.loadSamplingPointsArea();
        this.drawParcelsAndSamples();
    }
    loadPolygonsArea() {
        this.polygonShapes = [];
        if (this.areas[this.tabActive].fields && this.areas[this.tabActive].fields.length > 0) {
            this.areas[this.tabActive].fields.forEach((field) => this.polygonShapes.push(field));
        }
        else {
            this.polygonShapes.push({ polygon: this.areas[this.tabActive].geodata });
        }
    }
    loadSamplingPointsArea() {
        this.samplingPoints = [];
        this.samplingPoints = this.areas[this.tabActive].samplingPoints;
    }
    switchViewMode(m) {
        this.dismissModalUploading();
        this.viewMode = m;
    }
    buildColor() {
        const myDivObj = document.getElementsByClassName('hook_color');
        // @ts-ignore
        const myDivObjBgColor = window.getComputedStyle(myDivObj[this.tabActive]).backgroundColor;
        this.cropColor = myDivObjBgColor;
    }
    onChangeSamplingStepStatus(status) {
        this.viewZonesInMap();
    }
    async viewZonesInMap() {
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        try {
            const area = this.areaSelected;
            const url = '/tracking/gis_area/' + area.area.meta.id;
            const response = await axios_1.default.get(config.baseURL + url);
            if (response.data.gis_fields.length > 0) {
                area.area.fields = response.data.gis_fields.map((fieldObj) => new GeoEntities_1.Field(fieldObj));
            }
            this.$emit('loadAreaPlaygroundZones', response.data, area);
        }
        catch (e) {
            console.log(e.message);
        }
    }
    get showDeleteButton() {
        const gisFileUploadStatus = this.currentArea.life_cycle_area.find(status => status.slug === 'gis_file_upload');
        const sampleCollectingStatus = this.currentArea.life_cycle_area.find(status => status.slug === 'sample_collecting');
        const resultStatus = this.currentArea.life_cycle_area.find(status => status.slug === 'result');
        return this.currentArea.geodata
            && this.isFinishedStatus(gisFileUploadStatus.status)
            && (!this.isFinishedStatus(sampleCollectingStatus.status) || (this.isFinishedStatus(sampleCollectingStatus.status) && this.isBMK))
            && !this.isFinishedStatus(resultStatus.status);
    }
    isFinishedStatus(status) {
        return !(status === 'pending' || status === 'error' || status === 'waiting');
    }
    get currentArea() {
        var _a;
        return (((_a = this.areaSelected) === null || _a === void 0 ? void 0 : _a.area) || this.areaSelected);
    }
    onResetGisArea() {
        var _a;
        const area = this.currentArea;
        this.$emit('onResetGisArea', area.meta.id, ((_a = this.proposal) === null || _a === void 0 ? void 0 : _a.id) || 0);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], AreaPlaygroundYield.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'drag' })
], AreaPlaygroundYield.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], AreaPlaygroundYield.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], AreaPlaygroundYield.prototype, "product_level", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], AreaPlaygroundYield.prototype, "hasTabs", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], AreaPlaygroundYield.prototype, "areas", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], AreaPlaygroundYield.prototype, "areaSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], AreaPlaygroundYield.prototype, "proposal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], AreaPlaygroundYield.prototype, "user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line
], AreaPlaygroundYield.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('areaSelected')
], AreaPlaygroundYield.prototype, "updateMap", null);
AreaPlaygroundYield = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            HeaderMap: HeaderMap_vue_1.default,
            SampleProjectAssociation: SampleProjectAssociation_vue_1.default,
            MapSideBar: MapSideBar_vue_1.default,
            FooterMap: FooterMap_vue_1.default,
            Plus: lucide_vue_next_1.Plus,
            Minus: lucide_vue_next_1.Minus,
            Trash2: lucide_vue_next_1.Trash2,
            MapAttributions: bmk_ui_framework_1.MapAttributions,
            HelpCircle: lucide_vue_next_2.HelpCircle,
            Yield: bmk_ui_framework_1.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            ArrowRightIcon: bmk_ui_framework_1.ArrowRightIcon,
            AreaTabs: AreaTabs_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            Loader: bmk_ui_framework_1.Loader,
            XAloneIcon: bmk_ui_framework_1.XAloneIcon,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            CheckBox: bmk_ui_framework_1.CheckBox,
            PencilIcon: bmk_ui_framework_1.PencilIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            MultiDragDrop: bmk_ui_framework_1.MultiDragDrop,
            TopbarMap: TopbarMap_vue_1.default,
            BaseMap: BaseMap_vue_1.default,
            Link: bmk_ui_framework_1.Link,
            Modal: bmk_ui_framework_1.Modal,
            RateLogo: bmk_ui_framework_1.RateLogo,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            TrackingLogo: bmk_ui_framework_1.TrackingLogo,
            FileDown: lucide_vue_next_2.FileDown,
            TopbarDownloadedMap: TopbarDownloadedMap_vue_1.default,
            NewDragDrop: bmk_ui_framework_1.NewDragDrop,
            Dropdown: floating_vue_1.Dropdown,
            LoaderInline: bmk_ui_framework_1.LoaderInline,
            Metadata: Metadata_vue_1.default,
        },
    })
], AreaPlaygroundYield);
exports.default = AreaPlaygroundYield;
